import { TITLE_FONT } from '../text.utils'
import type { TicketElement } from '../TicketElement'

export class Title implements TicketElement {
  text: string
  paddingTop: number
  paddingBottom: number
  boxHeight: number
  fontSize: number

  constructor(text: string, { fontSize, height }: { fontSize?: number; height?: number } = {}) {
    this.text = text
    this.paddingTop = 16
    this.paddingBottom = 16
    this.boxHeight = height || 60
    this.fontSize = fontSize || 30
  }

  height(): number {
    return this.paddingTop + this.boxHeight + this.paddingBottom
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    top += this.paddingTop
    ctx.fillStyle = 'black'
    ctx.fillRect(0, top, width, this.boxHeight)

    ctx.font = `bold ${this.fontSize}px ${TITLE_FONT}`
    if (ctx.measureText(this.text).width > width) {
      this.fontSize = Math.floor((this.fontSize * width) / ctx.measureText(this.text).width)
      ctx.font = `bold ${this.fontSize}px ${TITLE_FONT}`
    }

    ctx.fillStyle = 'white'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'alphabetic'

    // Position text vertically centered
    const metrics = ctx.measureText(this.text)
    const textHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
    const y = top + this.boxHeight / 2 + textHeight / 2 - metrics.actualBoundingBoxDescent

    ctx.fillText(this.text, width / 2, y)
  }
}
